import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom } from 'rxjs/operators';

import * as fromStore from '../store';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BlogsGuard {
  private store = inject(Store);


  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.checkStore(route).pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  checkStore(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.store.select(fromStore.getBlogsLoaded).pipe(
      withLatestFrom(this.store.select(fromStore.getBlogsLoadedFor)),
      tap(([loaded, loadedFor]) => {
        if (!loaded || loadedFor !== route.params?.['diseaseProfileId']) {
          this.store.dispatch(fromStore.LoadBlogsByProfile({ profileId: route.params?.['diseaseProfileId'] }));
        }
      }),
      map(([loaded, loadedFor]) => loaded),
      filter(loaded => loaded),
      take(1)
    );
  }
}
